import type { IntlShape } from 'react-intl';
import type { AuditLogSourceType } from '@rossum/api-client/auditLogs';
import type { LocalizationKeys } from '../../../../i18n';
import type { ActivitySource } from '../model';

const FALLBACK_LABEL_ID: Record<AuditLogSourceType, LocalizationKeys> = {
  user: 'features.documentHistory.actor.unknownUser',
  email: 'features.documentHistory.actor.email',
  hook: 'features.documentHistory.actor.hook',
  system: 'features.documentHistory.actor.system',
  formula_fields: 'features.documentHistory.actor.formulaFields',
  rules: 'features.documentHistory.actor.rules',
};

export const getActorName = (intl: IntlShape, source: ActivitySource): string =>
  source.actor ??
  intl.formatMessage({
    id: source.sourceType
      ? FALLBACK_LABEL_ID[source.sourceType]
      : 'features.documentHistory.actor.unknown',
  });
